export default __webpack_public_path__ + "static/media/21_Epi_GG-Quiz-Art_Atmos-Hero-CG-L_VOG.486cc307.png";